const RU: Record<string, string> = {
  // Auth
  'auth.sign_in': 'Войти',
  'auth.sign_up': 'Регистрация',
  'auth.login_title': 'Вход',
  'auth.login_subtitle': 'Введи логин и пароль от своего аккаунта.',
  'auth.register_title': 'Создать аккаунт',
  'auth.register_subtitle': 'Сохраняй тренировки, питание и результаты.',
  'auth.login_field': 'Логин',
  'auth.password_field': 'Пароль',
  'auth.fio_field': 'Полное имя',
  'auth.no_account': 'Нет аккаунта?',
  'auth.create_one': 'Создать',
  'auth.have_account': 'Уже есть аккаунт?',
  'auth.create_account': 'Создать аккаунт',
  'auth.login_failed': 'Не удалось войти',
  'auth.register_failed': 'Регистрация не удалась',
  'auth.bad_credentials': 'Неверный логин или пароль',
  'auth.login_taken': 'Этот логин уже занят. Попробуй другой.',
  'auth.server_unreachable': 'Сервер недоступен. Проверь соединение и попробуй снова.',
  'auth.accept_legal': 'Подтверди согласия, чтобы продолжить',
  'auth.welcome': 'Добро пожаловать.',
  'auth.required_login': 'Введи логин',
  'auth.required_password': 'Введи пароль',
  'auth.min_login': 'Минимум 3 символа',
  'auth.min_password': 'Минимум 8 символов',
  'auth.fio_required': 'Укажи полное имя',
  'auth.signout': 'Выйти',

  // Nav
  // Mobile nav
  'mobile.menu.open': 'Открыть меню',
  'mobile.menu.close': 'Закрыть меню',
  'bottom_nav.home': 'Сегодня',
  'bottom_nav.workouts': 'Тренировки',
  'bottom_nav.nutrition': 'Питание',
  'bottom_nav.supps': 'БАДы',
  'bottom_nav.ai': 'AI',

  'nav.dashboard': 'Сегодня',
  'nav.exercises': 'Упражнения',
  'nav.workouts': 'Тренировки',
  'nav.supplements': 'БАДы',
  'nav.nutrition': 'Питание',
  'nav.calculators': 'Калькуляторы',
  'nav.coach': 'AI-помощник',
  'nav.notes': 'Заметки',
  'nav.settings': 'Настройки',
  'nav.profile': 'Профиль',
  'nav.integrations': 'Интеграции',
  'nav.billing': 'Подписка',
  'nav.admin': 'Админка',

  // Admin
  'admin.title': 'Админка',
  'admin.users': 'Пользователи',
  'admin.workouts': 'Тренировки',
  'admin.sets': 'Подходы',
  'admin.meals': 'Приёмы пищи',
  'admin.ai': 'AI запросов (24h)',
  'admin.supplements': 'БАДы в журнале',
  'admin.today': 'сегодня',
  'admin.refresh': 'Обновить',
  'admin.users.delete': 'Удалить',
  'admin.users.delete_confirm': 'Удалить пользователя @{login}? Действие необратимо.',
  'admin.users.delete_success': 'Пользователь @{login} удалён',
  'admin.users.delete_failed': 'Не удалось удалить пользователя',
  'admin.users.plan': 'Тариф',
  'admin.users.grant': 'Выдать',
  'admin.users.grant_success': 'Тариф {plan} выдан @{login}',
  'admin.users.grant_failed': 'Не удалось выдать тариф',
  'admin.prices.title': 'Тарифы',
  'admin.prices.subtitle': 'Цены для оплаты через ЮKassa, в рублях.',
  'admin.prices.pro_month': 'Pro · месяц',
  'admin.prices.pro_year': 'Pro · год',
  'admin.prices.premium_month': 'Premium · месяц',
  'admin.prices.premium_year': 'Premium · год',
  'admin.prices.save': 'Сохранить цены',
  'admin.prices.saved': 'Цены сохранены',
  'admin.prices.save_failed': 'Не удалось сохранить цены',
  'admin.prices.load_failed': 'Не удалось загрузить цены',

  // Pricing
  'pricing.title': 'Тарифы aniphys',
  'pricing.subtitle': 'Выбери тариф, который подходит твоей цели.',
  'pricing.period_month': 'Месяц',
  'pricing.period_year': 'Год',
  'pricing.popular': 'Рекомендуем',
  'pricing.free': 'Бесплатно',
  'pricing.per_month': 'мес.',
  'pricing.per_year': 'год',
  'pricing.cta_free': 'Базовый',
  'pricing.cta_upgrade': 'Оформить',
  'pricing.current': 'Текущий план',
  'pricing.back': 'Назад',
  'pricing.checkout_failed': 'Не удалось перейти к оплате',
  'pricing.disclaimer': 'Оплата через ЮKassa. Подписка автоматически продлевается, отменить можно в любой момент в разделе «Подписка».',
  'pricing.trial.title': '7 дней Pro бесплатно',
  'pricing.trial.desc': 'Попробуй AI-помощника, планировщик и интеграции. Банковская карта не нужна.',
  'pricing.trial.cta': 'Активировать 7 дней Pro',
  'pricing.trial.pending': 'Активируем…',
  'pricing.trial.started': 'Pro активирован на 7 дней. Приятной тренировки!',
  'pricing.trial.failed': 'Не удалось активировать пробный период',
  'pricing.plan.free.name': 'Free',
  'pricing.plan.free.tagline': 'Журнал и калькуляторы навсегда бесплатно.',
  'pricing.plan.pro.name': 'Pro',
  'pricing.plan.pro.tagline': 'AI-помощник, планировщик и интеграции.',
  'pricing.plan.premium.name': 'Premium',
  'pricing.plan.premium.tagline': 'Все возможности Pro и AI без лимита частоты.',

  // Plan features (shared between /pricing and /billing)
  'plan.feature.journal_unlimited': 'Журнал тренировок без лимитов',
  'plan.feature.exercises_catalog': 'Справочник упражнений',
  'plan.feature.supplements_catalog': 'Справочник БАДов',
  'plan.feature.calculators': 'Калькуляторы (BMI, BMR, 1RM, TDEE)',
  'plan.feature.ai_5_per_day': '5 AI-запросов в день',
  'plan.feature.ai_unlimited': 'AI-помощник: до 60 запросов в минуту',
  'plan.feature.workout_planner': 'AI-планировщик тренировок',
  'plan.feature.nutrition_tracking': 'Учёт питания и поиск продуктов',
  'plan.feature.integrations': 'Xiaomi / Apple Health интеграции',
  'plan.feature.notes_unlimited': 'Заметки без ограничений',
  'plan.feature.progress_charts': 'Графики прогресса',
  'plan.feature.all_pro': 'Все возможности Pro',
  'plan.feature.no_rate_limit': 'Без ограничения частоты AI-запросов',

  // Billing
  'billing.title': 'Подписка',
  'billing.subtitle': 'Управление тарифом, использованием и историей платежей.',
  'billing.current_plan': 'Текущий план',
  'billing.status': 'Статус',
  'billing.status.active': 'Активна',
  'billing.status.trialing': 'Пробный период',
  'billing.status.past_due': 'Просрочена',
  'billing.status.canceled': 'Отменена',
  'billing.status.pending': 'Ожидает оплаты',
  'billing.status.paused': 'Приостановлена',
  'billing.status.expired': 'Истекла',
  'billing.expires_at': 'Истекает',
  'billing.started_at': 'Начало',
  'billing.provider': 'Провайдер',
  'billing.cancel_pending': 'Подписка не будет продлена. Доступ сохранится до окончания периода.',
  'billing.upgrade': 'Перейти на Pro',
  'billing.cancel': 'Отменить продление',
  'billing.reactivate': 'Возобновить',
  'billing.change_plan': 'Сменить план',
  'billing.usage': 'Использование',
  'billing.history': 'История платежей',
  'billing.history_empty': 'Платежей ещё не было.',
  'billing.canceled_msg': 'Автопродление отключено',
  'billing.reactivated_msg': 'Подписка возобновлена',
  'billing.action_failed': 'Не удалось выполнить действие',
  'billing.terms_title': 'Условия подписки',
  'billing.terms_recurring':
    'Платные тарифы оформляются как подписка с автоматическим продлением. Оплата списывается через ЮKassa в начале каждого расчётного периода с привязанного способа оплаты.',
  'billing.terms_cancel':
    'Отменить автопродление можно в один клик в этом разделе. Доступ сохраняется до конца оплаченного периода.',
  'billing.terms_refund':
    'Возврат за неиспользованную часть периода оформляется по запросу на hello@aniphys.ru в течение 14 дней с даты оплаты, согласно Договору-оферте.',
  'billing.terms_offer_link': 'Договор-оферта',
  'billing.terms_privacy_link': 'Политика конфиденциальности',

  // Usage feature labels
  'usage.feature.ai_request_day': 'AI-запросов за сегодня',
  'usage.feature.ai_request_min': 'AI-запросов за минуту',
  'usage.feature.notes_total': 'Заметок',

  // Notes
  'notes.subtitle': 'Личные записи, дневник, идеи.',
  'notes.search': 'Поиск по заметкам',
  'notes.new': 'Новая',
  'notes.import': 'Импорт',
  'notes.export': 'Экспорт',
  'notes.empty': 'Заметок пока нет',
  'notes.empty_hint': 'Создай первую или импортируй из .json / .zip с .md файлами.',
  'notes.title_placeholder': 'Заголовок',
  'notes.body_placeholder': 'Запиши, что важно: план, самочувствие или заметки после тренировки.',
  'notes.tag_placeholder': 'Добавить тег…',
  'notes.tag_all': 'Все',
  'notes.save': 'Сохранить',
  'notes.delete': 'Удалить',
  'notes.confirm_delete': 'Удалить эту заметку?',
  'notes.back': 'К списку',
  'notes.preview': 'Превью',
  'notes.edit': 'Редактировать',
  'notes.body_empty': 'Пусто',
  'notes.remove_tag': 'Удалить тег',
  'notes.import_done': 'Импортировано: {i}, пропущено: {s}, ошибок: {f}',
  'page.notes': 'Заметки',

  // Calculators
  'calc.title': 'Калькуляторы',
  'calc.subtitle': 'Базовые расчёты по антропометрии и калоражу.',
  'calc.bmi': 'ИМТ',
  'calc.bmi.title': 'Индекс массы тела',
  'calc.bmi.weight': 'Вес (кг)',
  'calc.bmi.height': 'Рост (см)',
  'calc.bmi.result': 'Твой ИМТ',
  'calc.bmi.cat.severe_under': 'выраженный дефицит',
  'calc.bmi.cat.under': 'дефицит массы',
  'calc.bmi.cat.normal': 'норма',
  'calc.bmi.cat.over': 'избыток',
  'calc.bmi.cat.obese_1': 'ожирение I',
  'calc.bmi.cat.obese_2': 'ожирение II',
  'calc.bmi.cat.obese_3': 'ожирение III',
  'calc.bmr.title': 'BMR (базовый обмен)',
  'calc.bmr.formula': 'Mifflin-St Jeor',
  'calc.bmr.sex': 'Пол',
  'calc.bmr.age': 'Возраст',
  'calc.tdee.title': 'TDEE',
  'calc.tdee.activity': 'Активность',
  'calc.ideal.title': 'Идеальный вес',
  'calc.ideal.devine': 'Формула Девайна',
  'calc.bodyfat.title': 'Жировая масса (Navy)',
  'calc.bodyfat.neck': 'Шея (см)',
  'calc.bodyfat.waist': 'Талия (см)',
  'calc.bodyfat.hip': 'Бёдра (см)',
  'calc.bodyfat.result': '% жира',
  'calc.macros.title': 'Макросы',
  'calc.macros.protein': 'Белки',
  'calc.macros.fat': 'Жиры',
  'calc.macros.carb': 'Углеводы',
  'calc.macros.diet': 'Тип диеты',
  'calc.diet.balanced': 'Сбалансировано',
  'calc.diet.high_protein': 'Высокий белок',
  'calc.diet.low_carb': 'Низкоуглеводка',
  'calc.diet.keto': 'Кето',
  'calc.diet.bulk': 'Масса',
  'calc.diet.cut': 'Сушка',
  'calc.diet.if': 'Интервальное голодание',
  'calc.diet.vegan': 'Веганский',
  'calc.convert.title': 'Конвертер единиц',
  'calc.convert.lbs_kg': 'Фунты ↔ Килограммы',
  'calc.convert.mi_km': 'Мили ↔ Километры',
  'calc.convert.ft_cm': 'Футы ↔ Сантиметры',
  'calc.convert.in_cm': 'Дюймы ↔ Сантиметры',
  'calc.convert.f_c': 'Фаренгейт ↔ Цельсий',
  'calc.rm.title': '1RM и повторные максимумы',
  'calc.rm.weight': 'Вес (кг)',
  'calc.rm.reps': 'Повторы',
  'calc.rm.epley': 'Формула Эпли: 1RM = вес × (1 + повторы / 30)',
  'calc.rm.col_reps': 'Повторы',
  'calc.rm.col_weight': 'Вес',
  'calc.params': 'Параметры тела',
  'calc.params.hint': 'Укажи параметры для расчёта',
  'calc.bmi.empty': 'введи вес и рост',
  'calc.bmr.unit': 'ккал/день',
  'calc.ideal.delta': 'Δ к текущему',
  'calc.macros.from': 'из',
  'calc.macros.empty': 'нужны параметры',
  'calc.macros.fill_params': 'Заполни параметры тела для расчёта макросов',
  'calc.goal.title': 'Цель по весу',
  'calc.goal.hint': 'Дефицит/профицит для линейной динамики',
  'calc.goal.rate': 'Темп изменения (кг/нед)',
  'calc.goal.rate_hint': 'Минус = похудение. Безопасно: −0.5…−1 для cut, +0.25…+0.5 для bulk',
  'calc.goal.daily_delta': 'дельта в день',
  'calc.goal.target_kcal': 'целевой калораж',
  'calc.water.title': 'Вода',
  'calc.water.hint': 'Базовая норма + добавка на тренировку',
  'calc.water.train_h': 'Часы тренировки',
  'calc.water.unit': 'мл/день',
  'calc.water.formula': '33 мл/кг + 400 мл/час нагрузки',
  'page.calculators': 'Калькуляторы',

  // Tag-lines
  'app.tagline_1': 'Твой тренировочный',
  'app.tagline_2': 'дневник',
  'app.tagline_sub': 'Записывай подходы, следи за рабочими весами и возвращайся к прошлым результатам.',

  // Page titles
  'page.dashboard': 'Сегодня',
  'page.exercises': 'Упражнения',
  'page.exercise_new': 'Новое упражнение',
  'page.workouts': 'Тренировки',
  'page.workout_new': 'Новая тренировка',
  'page.supplements': 'БАДы',
  'page.supplement_new': 'Новый БАД',
  'page.nutrition': 'Питание',
  'page.nutrition_profile': 'Профиль питания',
  'page.settings': 'Настройки',

  // Dashboard
  'dash.welcome': 'С возвращением',
  'dash.snapshot': 'Сводка по тренировкам и каталогу.',
  'dash.kpi.exercises': 'Упражнений в каталоге',
  'dash.kpi.role': 'Твоя роль',
  'dash.kpi.today': 'Сегодня',
  'dash.last_7_days': 'Последние 7 дней',
  'dash.muscle_groups': 'Группы мышц',
  'dash.sets_short': 'подх.',
  'dash.hello': 'Привет,',
  'dash.ready': 'Готов к тренировке?',
  'dash.insight_eyebrow': 'Инсайт помощника',
  'dash.insight_another': 'Другой совет',
  'dash.insight_no_ai': 'Без AI: фокус на технике и базовых движениях.',
  'dash.todays_session': 'Тренировка дня',
  'dash.start': 'Старт',
  'dash.ask': 'Спросить',
  'dash.continue': 'Продолжить',
  'dash.no_active_workout': 'На сегодня тренировок нет',
  'dash.create_workout': 'Создать тренировку',
  'dash.fuel_today': 'Питание сегодня',
  'dash.fuel_kcal': 'Калории',
  'dash.fuel_protein': 'Белки',
  'dash.fuel_fat': 'Жиры',
  'dash.fuel_carb': 'Углеводы',
  'dash.fuel_empty': 'Заполни параметры питания',
  'dash.ai_fallback': 'AI-помощник временно недоступен. Попробуй ещё раз позже.',
  'dash.ai_thinking': 'Готовлю совет…',
  'dash.hrv': 'HRV',
  'dash.sleep': 'Сон',
  // Dashboard v2 (Apple Health × Yazio)
  'dash.greet_hi': 'Привет,',
  'dash.streak_days': 'дней',
  'dash.kcal_remaining': 'ккал осталось',
  'dash.kcal_over': 'ккал сверх нормы',
  'dash.kcal_today': 'ккал сегодня',
  'dash.add_meal': 'Добавить приём пищи',
  'dash.fuel_setup': 'Заполни параметры питания, чтобы видеть цели и баланс калорий.',
  'dash.fuel_setup_cta': 'Настроить питание',
  'dash.activity_volume': 'Объём',
  'dash.activity_training': 'Тренировка',
  'dash.activity_move': 'Активность',
  'dash.training_of_day': 'Тренировка дня',
  'dash.start_workout': 'Начать тренировку',
  'dash.no_workout_today': 'На сегодня тренировок нет',
  'dash.coach_q_technique': 'Спросить о технике',
  'dash.coach_q_postmeal': 'Что есть после?',
  'dash.tile_week_volume': 'Объём за сегодня',
  'dash.tile_bench_1rm': 'Жим: 1ПМ',
  'dash.tile_cohort': 'Похожие атлеты',
  'dash.tile_cohort_sub': 'медиана за 12 нед',
  'dash.focus_default': 'хорошего тренировочного дня',

  // Exercises
  'ex.subtitle': 'Найди упражнение по группе мышц и оборудованию.',
  'ex.new': 'Новое упражнение',
  'ex.no_matches': 'Ничего не найдено',
  'ex.no_matches_hint': 'Сбрось фильтры или поменяй запрос.',
  'ex.page_of': 'Страница {page} · всего {total}',
  'ex.edit': 'Редактировать',
  'ex.delete': 'Удалить',
  'ex.deleted': 'Удалено',
  'ex.delete_failed': 'Не удалось удалить',
  'ex.confirm_delete': 'Удалить это упражнение?',
  'ex.saved': 'Изменения сохранены',
  'ex.created': 'Упражнение создано',
  'ex.save_failed': 'Не удалось сохранить',
  'ex.description': 'Описание',
  'ex.no_description': '—',
  'ex.form.name': 'Название (англ)',
  'ex.form.name_ru': 'Название (рус)',
  'ex.form.description': 'Описание',
  'ex.form.difficulty': 'Сложность',
  'ex.form.muscle_groups': 'Группы мышц',
  'ex.form.image_drop': 'Перетащи изображение',
  'ex.form.video_drop': 'Перетащи видео',
  'ex.form.create_submit': 'Создать упражнение',
  'ex.form.save_submit': 'Сохранить изменения',
  'ex.title_new': 'Новое упражнение',
  'ex.title_edit': 'Редактирование упражнения',

  // Supplements
  'supp.subtitle': 'База знаний по добавкам с уровнями доказательности.',
  'supp.new': 'Добавить',
  'supp.no_matches': 'Ничего не найдено',
  'supp.edit': 'Редактировать',
  'supp.delete': 'Удалить',
  'supp.deleted': 'Удалено',
  'supp.delete_failed': 'Не удалось удалить',
  'supp.confirm_delete': 'Удалить этот БАД?',
  'supp.saved': 'Изменения сохранены',
  'supp.created': 'БАД добавлен',
  'supp.save_failed': 'Не удалось сохранить',
  'supp.description': 'Описание',
  'supp.summary': 'Кратко',
  'supp.dose': 'Дозировка',
  'supp.timing_label': 'Когда принимать',
  'supp.contraindications': 'Противопоказания',
  'supp.sources': 'Источники',
  'supp.title_new': 'Новый БАД',
  'supp.title_edit': 'Редактирование БАДа',
  'supp.page_of': 'Страница {page} · всего {total}',
  'supp.form.name': 'Название',
  'supp.form.name_ru': 'Название (рус.)',
  'supp.form.category': 'Категория',
  'supp.form.tier': 'Уровень доказательности',
  'supp.form.summary': 'Краткое описание',
  'supp.form.description': 'Полное описание',
  'supp.form.dose_min': 'Доза от (мг)',
  'supp.form.dose_max': 'Доза до (мг)',
  'supp.form.timing': 'Когда принимать',
  'supp.form.sources': 'Источники (по одной ссылке в строке)',
  'supp.form.contraindications': 'Противопоказания (по одному в строке)',
  'supp.form.image_drop': 'Перетащи изображение',
  'supp.form.create_submit': 'Создать',
  'supp.form.save_submit': 'Сохранить изменения',
  'supp.tier.any': 'Любой уровень',
  'supp.tier.high': 'Высокая уверенность',
  'supp.tier.medium': 'Средняя уверенность',
  'supp.tier.low': 'Низкая уверенность',
  'supp.tier.none': 'Нет подтверждения',
  'supp.category.any': 'Любая категория',
  'supp.category.protein': 'Протеины',
  'supp.category.creatine': 'Креатин',
  'supp.category.pre-workout': 'Предтреник',
  'supp.category.recovery': 'Восстановление',
  'supp.category.vitamin': 'Витамины',
  'supp.category.mineral': 'Минералы',
  'supp.category.adaptogen': 'Адаптогены',
  'supp.category.other': 'Прочее',
  'supp.timing.pre': 'Перед тренировкой',
  'supp.timing.post': 'После',
  'supp.timing.morning': 'Утром',
  'supp.timing.any': 'В любое время',
  'supp.timing.with_meal': 'С едой',
  'supp.filters.search': 'Поиск БАДов',
  'supp.sort.popular': 'Популярные в сообществе',
  'supp.sort.default': 'По умолчанию',
  'supp.usage.status.taking': 'Принимаю',
  'supp.usage.status.tried': 'Пробовал',
  'supp.usage.status.want_to_try': 'Хочу попробовать',
  'supp.usage.status.not_using': 'Не использую',
  'supp.usage.vote.helpful': 'Полезно',
  'supp.usage.vote.neutral': 'Нейтрально',
  'supp.usage.vote.unhelpful': 'Бесполезно',
  'supp.usage.effectiveness': 'Эффективность',
  'supp.usage.dose': 'Доза (мг)',
  'supp.usage.frequency': 'Приём',
  'supp.usage.notes': 'Заметки',
  'supp.usage.save': 'Сохранить',
  'supp.usage.saved': 'Сохранено',
  'supp.usage.title': 'Твой опыт',
  'supp.usage.freq.daily': 'Каждый день',
  'supp.usage.freq.2x_week': '2 раза в неделю',
  'supp.usage.freq.pre_workout': 'Перед тренировкой',
  'supp.usage.freq.custom': 'Иначе',
  'supp.community.title': 'Опыт сообщества',
  'supp.community.taking': 'принимают сейчас',
  'supp.community.tried': 'пробовали',
  'supp.community.empty': 'Пока недостаточно записей',
  'supp.community.helpful_pct': '% находят полезным',
  'supp.community.avg_effectiveness': 'Средняя оценка',
  'supp.community.top_goals': 'Чаще берут для',
  'supp.community.eff_distribution': 'Оценки',
  'supp.card.taking': 'Принимают: {count}',

  // Filters
  'filters.search_placeholder': 'Поиск упражнений',
  'filters.muscle_groups': 'Группы мышц',

  // Difficulty
  'difficulty.any': 'Любая сложность',
  'difficulty.beginner': 'Начинающий',
  'difficulty.intermediate': 'Средний',
  'difficulty.advanced': 'Продвинутый',

  // Workouts
  'workout.pick_date': 'Выбери дату',
  'workout.empty': 'В этот день тренировок нет.',
  'workout.new': 'Новая тренировка',
  'workout.date': 'Дата',
  'workout.create': 'Создать тренировку',
  'workout.created': 'Тренировка создана',
  'workout.create_failed': 'Не удалось создать',
  'workout.title': 'Тренировка',
  'workout.sub': 'Добавляй, изменяй и удаляй подходы.',
  'workout.sets': 'Подходы',
  'workout.add_set': 'Добавить подход',
  'workout.no_workouts': 'Тренировок ещё нет',
  'workout.set_added': 'Подход добавлен',
  'workout.set_saved': 'Сохранено',
  'workout.set_failed': 'Не удалось сохранить',
  'workout.set_remove_failed': 'Не удалось удалить',
  'workout.failure_short': 'до отказа',

  // Sets table
  'set.exercise': 'Упражнение',
  'set.kg': 'кг',
  'set.reps': 'повторы',
  'set.failure': 'отказ',
  'set.save': 'Сохранить',
  'set.delete': 'Удалить',
  'set.invalid_kg': 'Вес должен быть числом от 0 до 1000',
  'set.invalid_reps': 'Укажи целое число повторений от 1 до 1000',

  // Exercise picker dialog
  'picker.title': 'Выбери упражнение',
  'picker.search': 'Поиск…',
  'picker.no_results': 'Совпадений нет',

  // Settings
  'settings.title': 'Настройки',
  'settings.profile': 'Профиль',
  'settings.login_field': 'Логин',
  'settings.fio': 'Полное имя',
  'settings.height_cm': 'Рост (см)',
  'settings.weight_kg': 'Вес (кг)',
  'settings.macros_hint': 'Параметры для расчёта макросов задаются в',
  'settings.save': 'Сохранить профиль',
  'settings.saved': 'Сохранено',
  'settings.save_failed': 'Не удалось сохранить',
  'settings.ai.title': 'AI-обработка',
  'settings.ai.label': 'Разрешить AI-помощнику учитывать данные профиля',
  'settings.ai.description': 'При отключении серверная история диалогов, память помощника и локальная история этой вкладки будут удалены. Остальные функции продолжат работать.',
  'settings.ai.enabled': 'AI-функции включены',
  'settings.ai.disabled': 'AI-данные удалены, функции отключены',
  'settings.ai.failed': 'Не удалось изменить согласие',
  'settings.delete.title': 'Удаление аккаунта',
  'settings.delete.description': 'Удалит профиль, тренировки, питание, данные здоровья, историю AI, интеграции и персональную ML-модель. Платёжные события сохранятся только в обезличенном виде.',
  'settings.delete.button': 'Удалить аккаунт',
  'settings.delete.dialog_title': 'Удалить аккаунт безвозвратно?',
  'settings.delete.dialog_description': 'Восстановить данные после удаления не получится.',
  'settings.delete.confirmation': 'Введи DELETE для подтверждения',
  'settings.delete.password': 'Текущий пароль',
  'settings.delete.confirm': 'Удалить все мои данные',
  'settings.delete.success': 'Аккаунт удалён',
  'settings.delete.failed': 'Не удалось удалить аккаунт. Попробуй ещё раз позже.',

  // Coach personality
  'coach_style.nav': 'Характер помощника',
  'coach_style.title': 'Характер помощника',
  'coach_style.subtitle': 'Настрой, как AI-помощник общается с тобой.',
  'coach_style.mode': 'Режим',
  'coach_style.mode.auto': 'Авто',
  'coach_style.mode.manual': 'Вручную',
  'coach_style.mode.auto_hint': 'Помощник сам подстраивает стиль под твою манеру общения по мере диалога.',
  'coach_style.mode.manual_hint': 'Задай тон и подробность ответов.',
  'coach_style.auto.learned_title': 'Текущий выученный стиль',
  'coach_style.auto.readonly_hint': 'Эти значения коуч вывел из твоих сообщений. В авто-режиме они обновляются автоматически.',
  'coach_style.auto.updated': 'Обновлено: {ts}',
  'coach_style.auto.not_yet': 'Стиль уточнится после нескольких диалогов.',
  'coach_style.reset': 'Сбросить и переобучить',
  'coach_style.reset_done': 'Стиль сброшен. Новые диалоги помогут настроить ответы.',
  'coach_style.formality': 'Формальность',
  'coach_style.formality.low': 'Неформально',
  'coach_style.formality.high': 'Официально',
  'coach_style.verbosity': 'Подробность',
  'coach_style.verbosity.low': 'Кратко',
  'coach_style.verbosity.high': 'Подробно',
  'coach_style.directness': 'Прямота',
  'coach_style.directness.low': 'Мягко',
  'coach_style.directness.high': 'Прямо',
  'coach_style.warmth': 'Теплота',
  'coach_style.warmth.low': 'Сухо',
  'coach_style.warmth.high': 'Тепло',
  'coach_style.humor': 'Юмор',
  'coach_style.humor.low': 'Серьёзно',
  'coach_style.humor.high': 'С юмором',
  'coach_style.technicality': 'Терминология',
  'coach_style.technicality.low': 'Простой язык',
  'coach_style.technicality.high': 'Термины',
  'coach_style.address': 'Обращение',
  'coach_style.address.ty': 'На «ты»',
  'coach_style.address.vy': 'На «вы»',
  'coach_style.notes': 'Пожелания (свободно)',
  'coach_style.notes.placeholder': 'Напр.: не люблю воду, давай сразу к делу и с цифрами.',
  'coach_style.save': 'Сохранить стиль',
  'coach_style.saved': 'Стиль сохранён',
  'coach_style.save_failed': 'Не удалось сохранить стиль',
  'coach_style.load_failed': 'Не удалось загрузить настройки',

  // Common
  'common.loading': 'Загрузка…',
  'common.retry': 'Повторить',
  'common.reload': 'Перезагрузить',
  'common.go_home': 'На главную',
  'common.kg': 'кг',
  'common.g': 'г',
  'common.cm': 'см',
  'common.km': 'км',
  'common.mi': 'мили',
  'common.ft': 'футы',
  'common.in': 'дюймы',
  'common.not_found': 'Здесь ничего нет.',
  'common.something_broke': 'Что-то сломалось',
  'common.error': 'Ошибка',
  'common.open': 'Открыть',
  'billing.upgrade_required': 'Доступно на Pro',
  'billing.upgrade_required_plan': 'Нужен тариф {plan}',
  'billing.plan.pro': 'Pro',
  'billing.plan.premium': 'Premium',

  // States
  'state.no_exercises': 'Упражнений нет',
  'state.no_workouts': 'Тренировок нет',

  // UI primitives
  'ui.select_placeholder': 'Выбери…',
  'ui.selected_count': 'Выбрано: {count}',
  'ui.file_drop_hint': 'Нажми или перетащи файл',

  // Coach (ML)
  'coach.suggestion': 'Подсказка',
  'coach.use': 'Подставить',
  'coach.confidence.high': 'надёжно',
  'coach.confidence.medium': 'средне',
  'coach.confidence.low': 'слабо',
  'coach.confidence.heuristic': 'эвристика',
  'dash.coach': 'Coach подсказывает',

  // Coach (AI chat)
  'page.coach': 'AI-помощник',
  'coach.subtitle': 'Вопросы о тренировках, питании и твоих результатах.',
  'coach.placeholder': 'Вопрос о тренировке или питании…',
  'coach.send': 'Отправить',
  'coach.cancel': 'Остановить',
  'coach.clear': 'Очистить',
  'coach.sources': 'Источники',
  'coach.empty.0': 'Какие БАДы работают для сна?',
  'coach.empty.1': 'Программа на грудь и трицепс 60 минут',
  'coach.empty.2': 'Идеи завтрака на сушке',
  'coach.empty.3': 'Чем заменить креатин?',
  'coach.empty.4': 'Сколько белка нужно в день?',
  'coach.empty.5': 'Как восстановиться после тренировки?',
  'coach.thinking': 'Думаю…',
  'coach.error': 'Сбой связи с AI',
  'coach.no_context': 'Не нашёл данных в базе',
  'coach.ask_ai': 'Спросить AI',
  'coach.domain.all': 'Все',
  'coach.domain.exercises': 'Упражнения',
  'coach.domain.supplements': 'БАДы',
  'coach.domain.foods': 'Питание',
  'coach.voice_start': 'Записать голос',
  'coach.voice_stop': 'Остановить',
  'coach.voice_recording': 'Запись… {sec}с',
  'coach.voice_processing': 'Распознаю…',

  // Coach (agent) — universal assistant
  'coach.agent.title': 'Чем помочь?',
  'coach.agent.subtitle': 'Задай вопрос или выбери тему ниже.',
  'coach.agent.thinking': 'Думаю и собираю данные…',
  'coach.steps.count': 'Шаги · {n}',
  'coach.scroll_bottom': 'Вниз',
  'coach.answer.expand': 'Показать полностью',
  'coach.answer.collapse': 'Свернуть',
  // Live tool-call trace (what the agent is doing right now).
  'coach.step.default': 'Обращаюсь к данным',
  'coach.step.get_today_summary': 'Смотрю сегодняшние калории и БЖУ',
  'coach.step.get_user_profile': 'Открываю твой профиль',
  'coach.step.search_food': 'Ищу продукты',
  'coach.step.log_food': 'Готовлю запись еды',
  'coach.step.search_supplement': 'Ищу подходящие БАДы',
  'coach.step.get_workouts_recent': 'Смотрю последние тренировки',
  'coach.step.log_set': 'Готовлю запись подхода',
  'coach.step.get_body_measurements': 'Смотрю замеры тела',
  'coach.step.search_notes': 'Ищу в твоих заметках',
  'coach.step.get_note': 'Читаю заметку',
  'coach.step.get_user_supplements': 'Смотрю историю приёма добавок',
  'coach.step.get_supplement_community_stats': 'Собираю статистику по добавке',
  'coach.step.check_recommendation_safety': 'Проверяю безопасность для тебя',
  'coach.step.get_cohort_stats': 'Сравниваю с похожими атлетами',
  'coach.step.suggest_meal_fill': 'Подбираю продукты под план питания',
  'coach.step.set_reminder': 'Создаю напоминание',
  'coach.step.get_active_program': 'Открываю твою программу',
  'coach.step.start_program': 'Составляю программу',
  'coach.step.prepare_today_workout': 'Готовлю тренировку на сегодня',
  'coach.step.advance_program': 'Двигаю программу дальше',
  'coach.step.set_goal': 'Ставлю цель',
  'coach.step.get_goal_progress': 'Считаю прогресс к цели',
  'coach.step.get_coach_memory': 'Освежаю память о тебе',
  'coach.step.remember': 'Запоминаю важное о тебе',
  'coach.step.get_progress_analytics': 'Анализирую прогресс по журналу',
  'coach.step.web_search': 'Ищу в интернете',
  'coach.qa.plan.title': 'Собрать программу',
  'coach.qa.plan.desc': 'Неделя, нагрузка и прогрессия',
  'coach.qa.meal.title': 'Что съесть',
  'coach.qa.meal.desc': 'Подобрать еду под план питания',
  'coach.qa.progress.title': 'Анализ прогресса',
  'coach.qa.progress.desc': 'Рабочие веса, замеры и тренировки',
  'coach.qa.supps.title': 'Подобрать БАДы',
  'coach.qa.supps.desc': 'С учётом безопасности',
  'coach.qa.free.title': 'Свободный вопрос',
  'coach.qa.free.desc': 'Просто спроси',
  'coach.actions_label': 'Что я сделал',
  'coach.card.logged_food': 'Записал в дневник',
  'coach.card.logged_set': 'Подход записан',
  'coach.card.add': 'Добавить',
  'coach.card.added': 'Добавлено',
  'coach.card.adding': 'Добавляю…',
  'coach.card.open': 'Открыть',
  'coach.card.kcal': 'ккал',
  'coach.card.food_found': 'Нашёл продукты',
  'coach.card.supps_found': 'Подходящие БАДы',
  'coach.card.meal_fill': 'Варианты приёма пищи',
  'coach.card.cohort': 'Похожие на тебя',
  'coach.card.cohort_users': '{n} похожих атлетов',
  'coach.card.cohort_12w': 'медиана за 12 недель',
  'coach.card.today': 'Сегодня',
  'coach.card.profile': 'Твой профиль',
  'coach.card.measurements': 'Измерения тела',
  'coach.card.workouts': 'Последние тренировки',
  'coach.card.reminder': 'Напоминание создано',
  'coach.card.evidence': 'Доказательность',
  'coach.card.no_gap': 'План питания почти выполнен.',
  'coach.card.tool_done': 'Готово',
  'coach.attach.title': 'По теме ответа',
  'coach.attach.supp': 'Карточка БАДа в каталоге',
  'coach.attach.exercise': 'Упражнение в каталоге',
  'coach.card.progress': 'Прогресс по журналу',
  'coach.card.progress_volume': 'тоннаж',
  'coach.card.progress_workouts': '{n} трен.',
  'coach.card.progress_sets': '{n} подходов',
  'coach.card.progress_1rm': '~1ПМ {kg} кг',
  'coach.card.progress_empty': 'Пока нет записанных подходов за период.',
  'coach.card.exercise': 'Упражнение',
  'coach.tech.change': 'Изменить',
  'coach.plan.title': 'Составить тренировку',
  'coach.plan.goal': 'Цель',
  'coach.plan.time': 'Время (мин)',
  'coach.plan.equipment': 'Оборудование',
  'coach.plan.submit': 'Составить',
  'coach.meal.title': 'Подобрать приём пищи',
  'coach.send_intent': 'Спросить помощника',
  'coach.upgrade.title': 'Доступно с подпиской Pro',
  'coach.upgrade.desc': 'Выбери тариф, чтобы продолжить работу с помощником.',
  'coach.upgrade.cta': 'Смотреть тарифы',
  'coach.new_chat': 'Новый чат',
  'coach.cleared': 'История очищена',
  'coach.clear_failed': 'Не удалось очистить историю на сервере. Попробуй ещё раз.',
  'coach.ai_consent_required': 'Сначала разреши AI-помощнику использовать данные профиля.',
  'coach.context.profile': 'Профиль подключён',
  'coach.context.weight': 'вес {v} кг',
  'coach.context.goal': 'цель: {v}',
  'coach.context.allergies': 'аллергии: {v}',
  'coach.context.loading': 'Загружаем данные…',
  'coach.disclaimer': 'AI-помощник не заменяет консультацию врача. Информация носит общеобразовательный характер.',
  'coach.disclaimer_more': 'Подробнее',

  // Nutrition
  'nutr.subtitle': 'Дневник еды и расчёт макросов.',
  'nutr.add_meal': 'Добавить приём',
  'nutr.no_meals': 'В этом дне записей нет',
  'nutr.no_meals_hint': 'Добавь первый приём пищи, чтобы видеть калории и БЖУ за день.',
  'nutr.kcal': 'ккал',
  'nutr.protein': 'Белки',
  'nutr.fat': 'Жиры',
  'nutr.carbs': 'Углеводы',
  'nutr.consumed_of': '{consumed} из {target}',
  'nutr.slot.breakfast': 'Завтрак',
  'nutr.slot.lunch': 'Обед',
  'nutr.slot.dinner': 'Ужин',
  'nutr.slot.snack': 'Перекус',
  'nutr.meal_slot': 'Приём',
  'nutr.grams': 'граммы',
  'nutr.food': 'Продукт',
  'nutr.add': 'Добавить',
  'nutr.meal_added': 'Приём пищи добавлен',
  'nutr.profile.title': 'Параметры',
  'nutr.profile.sex': 'Пол',
  'nutr.profile.sex_male': 'Мужской',
  'nutr.profile.sex_female': 'Женский',
  'nutr.profile.age': 'Возраст',
  'nutr.profile.height': 'Рост (см)',
  'nutr.profile.weight': 'Вес (кг)',
  'nutr.profile.activity': 'Активность',
  'nutr.profile.goal': 'Цель',
  'nutr.profile.saved': 'Сохранено',
  'nutr.profile.save': 'Сохранить',
  'nutr.profile.missing': 'Сначала заполни параметры',
  'nutr.activity.sedentary': 'Сидячий',
  'nutr.activity.light': 'Лёгкая',
  'nutr.activity.moderate': 'Средняя',
  'nutr.activity.heavy': 'Тяжёлая',
  'nutr.activity.extreme': 'Очень тяжёлая',
  'nutr.goal.cut': 'Сушка',
  'nutr.goal.recomp': 'Рекомпозиция',
  'nutr.goal.lean_bulk': 'Чистая масса',
  'nutr.goal.bulk': 'Масса',
  'nutr.tab_search': 'Поиск',
  'nutr.tab_barcode': 'Штрихкод',
  'nutr.barcode_placeholder': 'Введи код',
  'nutr.barcode_lookup': 'Найти',
  'nutr.barcode_not_found': 'Продукт не найден',
  'nutr.start_typing': 'Начни вводить название продукта',
  'nutr.start_typing_hint': 'Например: творог 5%, банан или название бренда.',
  'nutr.searching': 'Ищем продукты…',
  'nutr.search_title': 'Что ты съел?',
  'nutr.search_subtitle': 'Найди продукт, затем укажи реальную порцию.',
  'nutr.search_source_nutriapix': 'Nutriapix',
  'nutr.search_source_openfoodfacts': 'Open Food Facts',
  'nutr.search_source_usda': 'USDA',
  'nutr.search_source_fatsecret': 'FatSecret',
  'nutr.search_source_external': 'Внешний каталог',
  'nutr.search_source_local': 'aniphys',
  'nutr.search_source_personal': 'Мой продукт',
  'nutr.search_resolving': 'Загружаем точные порции…',
  'nutr.search_unavailable': 'База aniphys и твои продукты доступны всегда.',
  'nutr.provider_searching': 'Ищем во внешних каталогах…',
  'nutr.provider_search_failed': 'Внешние каталоги сейчас недоступны. Локальные продукты доступны.',
  'nutr.provider_status.ready': 'Внешние каталоги доступны.',
  'nutr.provider_status.stale': 'Показаны сохранённые результаты и локальные продукты.',
  'nutr.provider_status.rate_limited': 'Внешние каталоги временно ограничили запросы. Локальные продукты доступны.',
  'nutr.provider_status.offline': 'Нет связи с внешними каталогами. Локальные продукты доступны.',
  'nutr.provider_status.unavailable': 'Внешние каталоги временно недоступны. Локальные продукты доступны.',
  'nutr.provider_status.unconfigured': 'Внешние каталоги не настроены. Локальные продукты и ручной ввод доступны.',
  'nutr.provider_food_incomplete': 'Недостаточно данных КБЖУ. Добавь продукт вручную.',
  'nutr.barcode_action': 'Найти по штрихкоду',
  'nutr.back_to_search': 'Вернуться к поиску',
  'nutr.portion_title': 'Сколько съел?',
  'nutr.portion_subtitle': 'Выбери обычную порцию или укажи точный вес.',
  'nutr.no_results_hint': 'Попробуй другое название или добавь продукт по штрихкоду.',
  'nutr.selected': 'Выбрано',
  'nutr.per_100': 'на 100 г',
  'nutr.portion_kcal': '{kcal} ккал за {grams} г',
  'nutr.search_label': 'Поиск продукта',
  'nutr.macros.short.protein': 'Б',
  'nutr.macros.short.fat': 'Ж',
  'nutr.macros.short.carb': 'У',
  'nutr.macros.short.fiber': 'Кл',

  // Meal/menu constructor
  'menu.title': 'Конструктор меню',
  'menu.subtitle': 'Собери типовой день из приёмов пищи и сохрани как шаблон.',
  'menu.add_to_slot': 'Добавить',
  'menu.totals': 'Итого за день',
  'menu.save_template': 'Сохранить шаблон',
  'menu.save_dialog_title': 'Новый шаблон меню',
  'menu.template_name': 'Название',
  'menu.template_name_placeholder': 'Например, питание в день тренировки',
  'menu.template_description': 'Описание (необязательно)',
  'menu.template_is_public': 'Публичный (виден другим)',
  'menu.saved': 'Шаблон сохранён',
  'menu.save_failed': 'Не удалось сохранить',
  'menu.templates_title': 'Мои шаблоны',
  'menu.no_templates': 'Пока нет сохранённых шаблонов',
  'menu.template_load': 'Загрузить',
  'menu.template_apply': 'Записать в дневник',
  'menu.template_delete': 'Удалить',
  'menu.applied': 'Записи добавлены: {n}',
  'menu.apply_failed': 'Не удалось применить шаблон',
  'menu.delete_confirm': 'Удалить шаблон?',
  'menu.deleted': 'Удалено',
  'menu.empty_lane': 'Пусто',
  'menu.suggest_fill': 'Заполни до цели',
  'menu.suggestions_title': 'Предложения ИИ',
  'menu.suggestion_accept': 'Добавить',
  'menu.suggestion_skip': 'Пропустить',
  'menu.suggestions_empty': 'План питания выполнен.',
  'menu.suggest_failed': 'Не удалось получить подсказки',
  'menu.grams_short': 'г',
  'menu.remove': 'Убрать',
  'menu.no_targets': 'Заполни параметры профиля, чтобы видеть цели.',
  'menu.open_recipes': 'Рецепты',

  // Recipes
  'recipes.title': 'Рецепты',
  'recipes.subtitle': 'Готовые рецепты на сушку, массу и поддержание.',
  'recipes.search_placeholder': 'Поиск по названию',
  'recipes.no_results': 'Ничего не найдено',
  'recipes.servings': 'Порции',
  'recipes.prep_time': 'Время приготовления',
  'recipes.minutes': 'мин',
  'recipes.ingredients': 'Ингредиенты',
  'recipes.instructions': 'Приготовление',
  'recipes.add_to_constructor': 'В конструктор',
  'recipes.added_to_constructor': 'Добавлено в конструктор',
  'recipes.scale': 'Пересчитать',
  'recipes.back': 'Назад к рецептам',
  'recipes.open_constructor': 'Открыть конструктор',

  // AI workout planner
  'nav.plan': 'AI-план',
  'plan.title': 'AI-конструктор тренировки',
  'plan.subtitle': 'Подберём упражнения под цель, время и оборудование. Для рабочих весов учтём прошлые тренировки.',
  'plan.goal': 'Цель',
  'plan.time': 'Длительность (мин)',
  'plan.equipment': 'Оборудование',
  'plan.equip.barbell': 'Штанга',
  'plan.equip.dumbbells': 'Гантели',
  'plan.equip.machines': 'Тренажёры',
  'plan.equip.cables': 'Кроссовер',
  'plan.equip.kettlebell': 'Гири',
  'plan.equip.bench': 'Скамья',
  'plan.equip.pullup': 'Турник',
  'plan.equip.bodyweight': 'Своё тело',
  'plan.muscle_groups': 'Группы мышц (опционально)',
  'plan.generate': 'Сгенерировать',
  'plan.regenerate': 'Сгенерировать другой',
  'plan.replace_one': 'Заменить',
  'plan.save': 'Создать тренировку',
  'plan.thinking': 'ИИ собирает план… ~5-10 сек',
  'plan.error': 'Не удалось сгенерировать. Попробуй ещё раз.',
  'plan.empty': 'Заполни параметры и нажми «Сгенерировать».',
  'plan.generation_failed': 'Не удалось собрать план под выбранное оборудование. Уточни оборудование и попробуй ещё раз.',
  'plan.sets': 'подх.',
  'plan.reps': 'повт.',
  'plan.rest': 'отдых',
  'plan.minutes': 'мин',
  'plan.estimated': 'Расчётное время',
  'plan.cta': 'Сгенерировать ИИ-план',
  'page.plan': 'AI-план тренировки',
  'coach.empty.6': 'Составь мне тренировку',

  // Telegram
  'tg.auth_failed': 'Не удалось войти через Telegram',
  'tg.opening': 'Открываем aniphys…',
  'settings.tg.title': 'Telegram',
  'settings.tg.status_linked': 'Привязан: @{name}',
  'settings.tg.status_unlinked': 'Telegram не привязан',
  'settings.tg.link_btn': 'Привязать Telegram',
  'settings.tg.unlink_btn': 'Отвязать',
  'settings.tg.unlinked': 'Telegram отвязан',
  'settings.tg.copy': 'Скопировать',
  'settings.tg.copied': 'Скопировано',
  'settings.tg.open_bot': 'Открыть бота',
  'settings.tg.instructions': 'Нажми «Открыть бота» и отправь /link {code}. Или используй прямую ссылку.',
  'settings.tg.expires_in': 'Код действует {n} мин',
  'settings.tg.waiting': 'Жду подтверждения…',
  'settings.tg.nudges_label': 'Получать утренние и вечерние напоминания',
  'settings.tg.nudges_hint': 'План на день утром и напоминание записать подходы вечером.',
  'settings.tg.nudges_on': 'Напоминания включены',
  'settings.tg.nudges_off': 'Напоминания выключены',
  'settings.tg.nudges_failed': 'Не удалось изменить настройку',

  // Integrations
  'integrations.title': 'Источники данных',
  'integrations.subtitle': 'Подключи то, чем уже пользуешься. Одного источника обычно достаточно.',
  'integrations.connected': 'Подключено',
  'integrations.wip': 'В разработке',
  'integrations.recent': 'Последние измерения',
  'integrations.no_measurements': 'Пока нет записей',
  'integrations.deleted': 'Удалено',
  'integrations.delete_failed': 'Не удалось удалить',
  'integrations.manual.title': 'Ручной ввод',
  'integrations.manual.desc': 'Вес и процент жира можно записать вручную.',
  'integrations.manual.weight_kg': 'Вес (кг)',
  'integrations.manual.body_fat_pct': 'Процент жира (%)',
  'integrations.manual.ts': 'Дата и время',
  'integrations.manual.save': 'Сохранить',
  'integrations.manual.saved': 'Измерение добавлено',
  'integrations.manual.save_failed': 'Не удалось сохранить',
  'integrations.manual.invalid_weight': 'Вес должен быть положительным числом',
  'integrations.manual.invalid_bf': 'Укажи процент жира числом от 0 до 100',
  'integrations.xiaomi.sync_failed': 'Не удалось синхронизировать',
  'integrations.xiaomi.sync_ok': 'Добавлено новых записей: {n}',
  'integrations.xiaomi.disconnect_ok': 'Интеграция отключена',
  'integrations.xiaomi.disconnect_failed': 'Не удалось отключить',
  'integrations.apple_health.title': 'Apple Health',
  'integrations.apple_health.desc': 'Здоровье, сон и измерения с iPhone.',
  'integrations.col.date': 'Дата',
  'integrations.col.kind': 'Показатель',
  'integrations.col.value': 'Значение',
  'integrations.col.source': 'Источник',
  'integrations.kind.weight': 'Вес',
  'integrations.kind.body_fat': 'Жир',
  'integrations.kind.muscle_mass': 'Мышечная масса',
  'integrations.kind.water': 'Вода',
  'integrations.kind.bone_mass': 'Костная масса',
  'integrations.kind.visceral_fat': 'Висцеральный жир',
  'integrations.kind.bmi': 'ИМТ',
  'integrations.ah.connect_btn': 'Подключить',
  'integrations.ah.disconnect_btn': 'Отключить',
  'integrations.ah.disconnected': 'Apple Health отключён',
  'integrations.ah.connect_failed': 'Не удалось подключить Apple Health',
  'integrations.ah.disconnect_failed': 'Не удалось отключить',
  'integrations.ah.last_sync': 'Последняя выгрузка: {ts}',
  'integrations.ah.last_sync_never': 'Данных ещё не было',
  'integrations.ah.dialog_title': 'Подключение Apple Health',
  'integrations.ah.intro': 'Бесплатное приложение Health Auto Export пересылает данные из Apple Health на сервер по расписанию.',
  'integrations.ah.appstore_btn': 'Открыть в App Store',
  'integrations.ah.steps_title': 'Шаги настройки в Health Auto Export:',
  'integrations.ah.step_1': 'Установи приложение Health Auto Export и открой его.',
  'integrations.ah.step_2': 'Перейди в Automations → Add Automation → REST API.',
  'integrations.ah.step_3': 'Method: POST. URL: вставь значение ниже.',
  'integrations.ah.step_4': 'В Headers добавь заголовок X-AppleHealth-Token со значением токена.',
  'integrations.ah.step_5': 'Metrics: Weight, Body Fat Percentage, Lean Body Mass, Body Mass Index.',
  'integrations.ah.step_6': 'Schedule: Daily. Сохрани автоматизацию.',
  'integrations.ah.url_label': 'URL загрузки',
  'integrations.ah.token_label': 'X-AppleHealth-Token',
  'integrations.ah.copy': 'Скопировать',
  'integrations.ah.copied': 'Скопировано',
  'integrations.ah.show_curl': 'Показать curl для проверки',
  'integrations.ah.hide_curl': 'Скрыть curl',
  'integrations.ah.close': 'Закрыть',

  // Mi Scale 2 — Web Bluetooth
  'integrations.mi_ble.title': 'Весы Xiaomi с Bluetooth',
  'integrations.mi_ble.desc': 'Разовое измерение напрямую с совместимых весов, без аккаунта Zepp.',
  'integrations.mi_ble.hint': 'Открой страницу в Chrome на Android или компьютере. Подключение действует только пока открыта страница.',
  'integrations.mi_ble.unsupported': 'Браузер не поддерживает Web Bluetooth. Используй Chrome на Android или десктопе.',
  'integrations.mi_ble.connect_btn': 'Подключить весы',
  'integrations.mi_ble.scanning': 'Поиск…',
  'integrations.mi_ble.connected': 'Подключено. Встань на весы для измерения.',
  'integrations.mi_ble.connect_failed': 'Не удалось подключить: {err}',
  'integrations.mi_ble.age': 'Возраст',
  'integrations.mi_ble.height_cm': 'Рост (см)',
  'integrations.mi_ble.sex': 'Пол',
  'integrations.mi_ble.sex_male': 'Мужской',
  'integrations.mi_ble.sex_female': 'Женский',
  'integrations.mi_ble.kg': 'кг',
  'integrations.mi_ble.kcal': 'ккал',
  'integrations.mi_ble.bmr': 'Базовый метаболизм',
  'integrations.mi_ble.save': 'Сохранить измерение',
  'integrations.mi_ble.saved': 'Сохранено',
  'integrations.mi_ble.save_failed': 'Не удалось сохранить: {err}',

  // Strava
  'integrations.strava.title': 'Strava',
  'integrations.strava.desc': 'Импорт кардио-активностей (бег, велосипед, плавание).',
  'integrations.strava.connect': 'Подключить Strava',
  'integrations.strava.connected': 'Strava подключена',
  'integrations.strava.connect_failed': 'Не удалось подключить Strava',
  'integrations.strava.sync_now': 'Синхронизировать',
  'integrations.strava.sync_ok': 'Импортировано активностей: {n}',
  'integrations.strava.sync_failed': 'Не удалось синхронизировать Strava',
  'integrations.strava.disconnect': 'Отключить',
  'integrations.strava.disconnect_ok': 'Strava отключена',
  'integrations.strava.disconnect_failed': 'Не удалось отключить',
  'integrations.strava.last_sync': 'Последняя синхронизация: {ts}',
  'integrations.strava.never_synced': 'Ещё не синхронизировалось',

  // Page sections + generic provider card states
  'integrations.section.devices': 'Устройства и сервисы',
  'integrations.section.devices_desc': 'Выбери сервис и проверь доступные способы подключения.',
  'integrations.section.manual': 'Ручной ввод и импорт',
  'integrations.section.manual_desc': 'Добавь измерения вручную или загрузи выгрузку из приложения.',
  'integrations.status.connect': 'Подключить',
  'integrations.status.refresh': 'Обновить',
  'integrations.status.disconnect': 'Отключить',
  'integrations.status.synced': 'Синхронизировано {ts}',
  'integrations.status.never_synced': 'Ещё не синхронизировалось',
  'integrations.status.connected': 'Подключено',
  'integrations.status.soon': 'Скоро',
  'integrations.status.soon_hint': 'Интеграция появится в ближайшее время.',
  'integrations.status.sync_ok': 'Импортировано записей: {n}',
  'integrations.status.sync_failed': 'Не удалось синхронизировать',
  'integrations.status.connect_failed': 'Не удалось подключить',
  'integrations.status.disconnect_ok': 'Интеграция отключена',
  'integrations.status.disconnect_failed': 'Не удалось отключить',

  // Fitbit
  'integrations.fitbit.title': 'Fitbit',
  'integrations.fitbit.desc': 'Вес, процент жира, активность.',
  // Polar
  'integrations.polar.title': 'Polar',
  'integrations.polar.desc': 'Дневная активность и вес тела.',
  // Oura
  'integrations.oura.title': 'Oura',
  'integrations.oura.desc': 'Сон, готовность, ВСР, активность.',
  // Whoop
  'integrations.whoop.title': 'Whoop',
  'integrations.whoop.desc': 'Восстановление, нагрузка, сон.',
  // Garmin (OAuth1 — пока недоступно)
  'integrations.garmin.title': 'Garmin Connect',
  'integrations.garmin.desc': 'Активность, пульс, сон.',

  'integrations.telegram.title': 'Telegram',
  'integrations.telegram.desc': 'Бот @aniphys_bot: привязка аккаунта и напоминания о тренировках.',

  'integrations.file_import.btn_fit': 'Загрузить .fit / .tcx / .gpx',
  'integrations.file_import.ok': 'Импортировано: {i}, пропущено: {s}, ошибок: {e}',
  'integrations.file_import.failed': 'Не удалось импортировать файл',
  'integrations.file_import.uploading': 'Загрузка… {pct}%',
  'integrations.file_import.processing': 'Обрабатываем файл…',
  'integrations.file_import.native_soon': 'Синхронизация через приложение пока недоступна.',
  'integrations.xiaomi.workouts_soon': 'Синхронизация тренировок через приложение пока недоступна.',
  'integrations.huawei.tile_desc': 'Импорт тренировок из файлов .fit, .tcx, .gpx.',
  'integrations.ah.upload_btn': 'Загрузить export.zip',
  'integrations.ah.upload_hint': 'Открой «Здоровье», нажми на фото профиля и выбери «Экспортировать медданные». Загрузи полученный ZIP или export.xml.',

  // New measurement kinds
  'integrations.kind.hrv': 'ВСР',
  'integrations.kind.sleep_hours': 'Сон (ч)',
  'integrations.kind.readiness': 'Готовность',
  'integrations.kind.resting_hr': 'Пульс покоя',
  'integrations.kind.vo2max': 'МПК (VO₂max)',

  // Huawei Health JSON import
  'integrations.huawei.title': 'Huawei Health',
  'integrations.huawei.desc': 'Импорт JSON-выгрузки из Huawei Health (вес, состав тела).',
  'integrations.huawei.upload_btn': 'Загрузить JSON',
  'integrations.huawei.how_to': 'Как выгрузить?',
  'integrations.huawei.upload_ok': 'Принято: {a}, пропущено: {s}',
  'integrations.huawei.upload_failed': 'Не удалось загрузить файл',
  'integrations.huawei.disconnect': 'Отключить',
  'integrations.huawei.disconnect_ok': 'Huawei отключён',
  'integrations.huawei.disconnect_failed': 'Не удалось отключить',
  'integrations.huawei.last_upload': 'Последняя выгрузка: {ts}',
  'integrations.huawei.dialog_title': 'Выгрузка данных из Huawei Health',
  'integrations.huawei.dialog_intro': 'Huawei отдаёт ZIP-архив через Privacy Center. Распакуй и загрузи нужный JSON сюда.',
  'integrations.huawei.step_1': 'Открой приложение Huawei Health → раздел «Я».',
  'integrations.huawei.step_2': 'Перейди в Privacy Center → Download personal data.',
  'integrations.huawei.step_3': 'Выбери Health Data и подтверди. На почту придёт ссылка.',
  'integrations.huawei.step_4': 'Скачай и распакуй ZIP. Найди файл Weight Records.json (или body_data.json).',
  'integrations.huawei.step_5': 'Нажми «Загрузить JSON» выше и выбери файл.',

  // Generic CSV/JSON import
  'integrations.import.title': 'CSV / JSON импорт',
  'integrations.import.desc': 'Загрузить измерения из CSV или JSON.',
  'integrations.import.btn': 'Загрузить CSV / JSON',
  'integrations.import.ok': 'Импортировано: {i}, пропущено: {s}, ошибок: {f}',
  'integrations.import.failed': 'Не удалось импортировать',
  'integrations.import.hint': 'CSV: заголовок ts,kind,value,unit,source\nJSON: {"measurements":[{"ts":"…","kind":"weight","value":80,"unit":"kg","source":"manual"}]}',

  // Health / medical safety profile
  'health.banner': 'Эти данные позволяют AI-агенту давать безопасные советы. Конфиденциально хранятся в РФ.',
  'health.conditions.title': 'Заболевания',
  'health.conditions.placeholder': 'Добавить своё',
  'health.conditions.add': 'Добавить',
  'health.conditions.notes': 'Заметка (необязательно)',
  'health.allergies.title': 'Аллергии',
  'health.allergies.placeholder': 'Добавить свою',
  'health.medications.title': 'Лекарства',
  'health.medications.name': 'Название',
  'health.medications.dose': 'Доза',
  'health.medications.frequency': 'Частота',
  'health.medications.add': 'Добавить лекарство',
  'health.medications.remove': 'Удалить',
  'health.diet.title': 'Диета',
  'health.severity.label': 'Тяжесть',
  'health.severity.mild': 'Лёгкая',
  'health.severity.moderate': 'Умеренная',
  'health.severity.severe': 'Тяжёлая',
  'health.cond.diabetes_type1': 'Диабет 1 типа',
  'health.cond.diabetes_type2': 'Диабет 2 типа',
  'health.cond.hypertension': 'Гипертония',
  'health.cond.hypotension': 'Гипотония',
  'health.cond.heart_disease': 'Болезнь сердца',
  'health.cond.asthma': 'Астма',
  'health.cond.kidney_disease': 'Болезнь почек',
  'health.cond.liver_disease': 'Болезнь печени',
  'health.cond.thyroid_hyper': 'Гипертиреоз',
  'health.cond.thyroid_hypo': 'Гипотиреоз',
  'health.cond.ibs': 'СРК',
  'health.cond.gerd': 'ГЭРБ',
  'health.cond.celiac': 'Целиакия',
  'health.cond.pcos': 'СПКЯ',
  'health.cond.hypoglycemia': 'Гипогликемия',
  'health.cond.pregnancy': 'Беременность',
  'health.cond.epilepsy': 'Эпилепсия',
  'health.allergy.nuts': 'Орехи',
  'health.allergy.peanuts': 'Арахис',
  'health.allergy.gluten': 'Глютен',
  'health.allergy.lactose': 'Лактоза',
  'health.allergy.eggs': 'Яйца',
  'health.allergy.fish': 'Рыба',
  'health.allergy.shellfish': 'Морепродукты',
  'health.allergy.soy': 'Соя',
  'health.allergy.pollen': 'Пыльца',
  'health.allergy.latex': 'Латекс',
  'health.allergy.chocolate': 'Шоколад',
  'health.allergy.citrus': 'Цитрусовые',
  'health.allergy.dairy': 'Молочные продукты',
  'health.diet.vegetarian': 'Вегетарианец',
  'health.diet.vegan': 'Веган',
  'health.diet.kosher': 'Кошер',
  'health.diet.halal': 'Халяль',
  'health.diet.low_sodium': 'Мало соли',
  'health.diet.low_fat': 'Мало жиров',
  'health.diet.no_red_meat': 'Без красного мяса',
  'health.diet.no_pork': 'Без свинины',

  // Supplement safety check (inline on detail page)
  'supp.safety.check': 'Проверить безопасность',
  'supp.safety.checking': 'Проверяем…',
  'supp.safety.no_known_matches': 'Явных совпадений не найдено',
  'supp.safety.review_required': 'Нужна проверка',
  'supp.safety.incomplete': 'Проверка неполная',
  'supp.safety.warnings_title': 'Предупреждения',
  'supp.safety.contras_title': 'Противопоказания',
  'supp.safety.failed': 'Не удалось проверить',

  // Onboarding wizard (/welcome)
  'welcome.step_of': 'Шаг {current} из {total}',
  'welcome.next': 'Далее',
  'welcome.prev': 'Назад',
  'welcome.skip': 'Пропустить',
  'welcome.finish': 'Готово',
  'welcome.saving': 'Сохраняем…',
  'welcome.save_failed': 'Не удалось сохранить',
  'welcome.step1.label': 'Цель',
  'welcome.step1.title': 'Какая у тебя цель?',
  'welcome.step1.subtitle': 'AI-агент будет подбирать тренировки и питание под неё.',
  'welcome.step2.label': 'Опыт',
  'welcome.step2.title': 'Опыт и частота тренировок',
  'welcome.step2.subtitle': 'Это влияет на нагрузку и план.',
  'welcome.step3.label': 'Параметры',
  'welcome.step3.title': 'Параметры тела',
  'welcome.step3.subtitle': 'Нужны для расчёта калорий и макросов.',
  'welcome.step4.label': '1RM',
  'welcome.step4.title': '1RM бенчмарки',
  'welcome.step4.subtitle': 'Укажи рабочие веса, если знаешь. Этот шаг можно пропустить.',
  'welcome.step5.label': 'Здоровье',
  'welcome.step5.title': 'Здоровье и аллергии',
  'welcome.step5.subtitle': 'Можешь пропустить, но AI-агент сможет давать безопасные советы только если знает.',
  'welcome.goal.mass': 'Масса',
  'welcome.goal.cut': 'Сушка',
  'welcome.goal.maintain': 'Поддержание',
  'welcome.goal.strength': 'Сила',
  'welcome.goal.endurance': 'Выносливость',
  'welcome.goal.general_health': 'Здоровье',
  'welcome.experience.label': 'Уровень опыта',
  'welcome.experience.novice': 'Новичок',
  'welcome.experience.intermediate': 'Средний',
  'welcome.experience.advanced': 'Продвинутый',
  'welcome.freq.label': 'Тренировок в неделю',
  'welcome.freq.value': '{n} раз/нед.',
  'welcome.body_fat.label': '% жира (необязательно)',
  'welcome.body_fat.placeholder': 'например, 18',
  'welcome.benchmarks.title': 'Рабочие веса',
  'welcome.benchmarks.weight': 'Вес',
  'welcome.benchmarks.reps': 'Повт.',
  'welcome.benchmarks.kg': 'кг 1RM',
  'welcome.benchmarks.bench': 'Жим лёжа',
  'welcome.benchmarks.squat': 'Присед',
  'welcome.benchmarks.deadlift': 'Становая',
  'welcome.benchmarks.ohp': 'Жим стоя',
  'welcome.benchmarks.hint': '1RM считается по формуле Эпли. Пустые поля будут пропущены.',
  'welcome.success.title': 'Всё готово',
  'welcome.success.subtitle': 'Настройки сохранены. Можно добавить первую тренировку.',
  'welcome.success.cta': 'Открыть кабинет',
  'welcome.next_step.workout': 'Создать первую тренировку',
  'welcome.next_step.scale': 'Подключить Mi Scale',
  'welcome.next_step.nutrition': 'Заполнить рацион',

  // PWA install / update prompt
  'pwa.update.title': 'Доступно обновление',
  'pwa.update.body': 'Загружена новая версия aniphys.',
  'pwa.update.waiting_body': 'Обновление ждёт. Заверши текущую работу и обнови приложение.',
  'pwa.update.action': 'Обновить',
  'pwa.update.later': 'Позже',
  'pwa.install.title': 'Установить aniphys',
  'pwa.install.body': 'Добавь приложение на главный экран для быстрого доступа.',
  'pwa.install.action': 'Установить',
  'pwa.offline.title': 'Нет подключения',
  'pwa.offline.body': 'Доступно сохранённое содержимое. Новые изменения не сохранятся.',
  'pwa.dismiss': 'Закрыть',
};

export type TKey = keyof typeof RU | string;

export function t(key: TKey, params?: Record<string, string | number>): string {
  let s = RU[key as string] ?? (key as string);
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    }
  }
  return s;
}
